import Vue from 'vue'

import './styles/quasar.styl'
import lang from 'quasar/lang'
import '@quasar/extras/material-icons/material-icons.css'
import Quasar from 'quasar/src/vue-plugin.js';import Ripple from 'quasar/src/directives/Ripple.js';import Notify from 'quasar/src/plugins/Notify.js';


Vue.use(Quasar, {
  config: {},
  plugins: {
    Notify
  },
  directives: {
    Ripple
  },
  lang: lang
})


const { notify } = Vue.prototype.$q
export {
  notify
}